'use client';
'use strict';

var jsxRuntime = require('react/jsx-runtime');
var tailwindMerge = require('tailwind-merge');
var Typography = require('../../Base/Typography/Typography.js');
require('../../Base/Layouts/Box/Box.js');
require('../../Base/Layouts/FullBleed/FullBleed.js');
var CheckboxCard_parts = require('./CheckboxCard.parts.js');

/**
 * 체크박스와 함께 아이콘, 제목, 설명을 포함하는 카드 형태의 선택 컴포넌트입니다.
 *
 * @component
 * @param {Object} props
 * @param {boolean} [props.disabled=false] - 컴포넌트의 비활성화 여부
 * @param {boolean} [props.checked=false] - 체크박스의 선택 상태
 * @param {boolean} [props.isError=false] - 오류 상태 표시 여부
 * @param {(event: React.ChangeEvent<HTMLInputElement>) => void} props.onChange - 체크박스 상태 변경 시 호출되는 핸들러
 * @param {boolean} [props.isWide=false] - 넓은 형태로 표시할지 여부
 * @param {string} [props.className] - 추가적인 CSS 클래스
 * @param {string} props.iconName - 표시할 아이콘의 이름
 * @param {string} props.title - 카드의 제목
 * @param {string} [props.description] - 카드의 설명 텍스트
 * @param {string} [props.testId] - 테스트를 위한 ID
 * @param {string} [props.name] - 체크박스의 name 속성
 * @param {string} [props.value] - 체크박스의 value 속성
 *
 * @example
 * // 기본 사용 예시
 * <CheckboxCard
 *   iconName="user"
 *   title="사용자 정보"
 *   description="사용자의 기본 정보를 포함합니다"
 *   onChange={(e) => console.log('체크박스 상태:', e.target.checked)}
 * />
 *
 * // 넓은 형태의 비활성화된 체크박스 카드
 * <CheckboxCard
 *   iconName="settings"
 *   title="설정"
 *   description="시스템 설정을 관리합니다"
 *   isWide={true}
 *   disabled={true}
 * />
 *
 * // 에러 상태의 체크박스 카드
 * <CheckboxCard
 *   iconName="warning"
 *   title="오류 상태"
 *   description="오류가 발생했습니다"
 *   isError={true}
 *   checked={true}
 * />
 */ const CheckboxCard = ({ disabled = false, checked = false, isError = false, onChange, isWide = false, className, iconName, title, description, testId, name, value })=>{
    return jsxRuntime.jsx("label", {
        "data-testid": testId,
        role: "checkbox-card",
        className: "group",
        children: jsxRuntime.jsxs(CheckboxCard_parts.CheckboxCardContainer, {
            "data-testid": "design-system-checkboxCard--container",
            checked: checked,
            isError: isError,
            isWide: isWide,
            disabled: disabled,
            className: className,
            children: [
                jsxRuntime.jsx(CheckboxCard_parts.StyledCheckbox, {
                    isWide: isWide,
                    checked: checked,
                    onChange: onChange,
                    isError: isError,
                    disabled: disabled,
                    name: name,
                    value: value
                }),
                jsxRuntime.jsx(CheckboxCard_parts.CheckboxCardIcon, {
                    isError: isError,
                    checked: checked,
                    iconName: iconName,
                    disabled: disabled
                }),
                jsxRuntime.jsxs(CheckboxCard_parts.TitleContainer, {
                    isWide: isWide,
                    "data-testid": "design-system-checkboxCard--titleBox",
                    children: [
                        jsxRuntime.jsx(Typography, {
                            "data-testid": "design-system-checkboxCard--title",
                            variant: "body1",
                            className: tailwindMerge.twMerge('font-medium', isWide ? 'text-left' : 'text-center', disabled ? 'text-w-gray-300' : 'text-w-gray-900'),
                            children: title
                        }),
                        description && jsxRuntime.jsx(Typography, {
                            variant: "body2",
                            className: tailwindMerge.twMerge('font-normal', isWide ? 'text-left' : 'text-center', disabled ? 'text-w-gray-300' : 'text-w-gray-600'),
                            "data-testid": "design-system-checkboxCard--description",
                            children: description
                        })
                    ]
                })
            ]
        })
    });
};

module.exports = CheckboxCard;
